<template>
  <div
    v-if="showModal"
    class="modal fade"
    :class="{
      in: showModal
    }"
    id="partner-selector"
    :style="{
      display: showModal ? 'block' : 'none',
      background: showModal ? '#0005' : 'transparent'
    }"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="searchModalLabel">
            <i class="fa fa-fw fa-lg fa-user-plus text-primary"></i>
            {{ $label("common.partner", "Partner") }}
          </h4>
        </div>
        <div class="modal-body v-form">
          <fieldset>
            <div class="row">
              <section class="col col-12">
                <select
                  class="form-control partner-select"
                  v-model="selectedPartner"
                >
                  <option
                    v-for="partner in partners"
                    :value="partner.id"
                    v-bind:key="partner.id"
                    >{{ partner.name }}</option
                  >
                </select>
              </section>
            </div>
            <div class="row mb-8"><div class="col-xs-12">&nbsp;</div></div>
          </fieldset>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            id="submit-filter"
            class="btn btn-primary"
            :disabled="!selectedPartner"
            @click="handleSelect"
          >
            <i class="fa fa-fw fa-lg fa-save"></i>
            {{ $label("common.confirm", "Confirm") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnerModal",

  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    partners: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedPartner: null
    };
  },

  methods: {
    handleSelect() {
      if (!this.selectedPartner) return;
      const selectedPartner = this.partners.find(
        partner => partner.id === this.selectedPartner
      );
      localStorage.setItem("partnerId", selectedPartner.id);
      localStorage.setItem("partnerCode", selectedPartner.code);
      this.$router.push({
        name: "UsersOverview"
      });
    }
  },

  watch: {
    partners(newPartners) {
      if (newPartners.length > 0) {
        this.selectedPartner = newPartners[0].id;
      }
    }
  }
};
</script>

<style scoped>
.partner-select {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  font-weight: bold;
}
</style>
